import React from 'react';
import Search from 'layouts/header/search/search';
import Container from 'atomic/utilization/container';
import Navigation from 'layouts/header/navigation/navigation';
import CategoryList from 'layouts/header/category-list/category-list';
import { useSelector } from '@ecommerce/nest-ssr/common';
import SearchOptionInterface from 'layouts/header/search/search-option.interface';
import CategoryListOverlay from 'layouts/header/category-list-overlay/category-list-overlay';
import useToggle from 'hooks/use-toggle';

import './header.desktop.scss';

export const HeaderDesktop: React.FC = () => {
    const [isOpenMenu, menuState] = useToggle();
    const departments = useSelector((state: { departments: SearchOptionInterface[]; }) => state.departments ?? []);

    return (
        <>
            <header className="header">
                <Container>
                    <div className="header__partial">
                        <Navigation onToggle={menuState.toggle} isOpen={isOpenMenu}/>
                        <Search/>
                    </div>
                    <CategoryList onClose={menuState.toggle} isOpenMenu={isOpenMenu} departments={departments}/>
                </Container>
            </header>
            {isOpenMenu && <CategoryListOverlay onClose={menuState.toggle}/>}
        </>
    );
};

export default HeaderDesktop;
